import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './style/WhyChooseUs.css';

const reasons = [
  {
    title: "Expert Technicians",
    desc: "Highly skilled and certified professionals with years of experience."
  },
  {
    title: "Quick Turnaround",
    desc: "We strive to provide fast and efficient service to minimize downtime."
  },
  {
    title: "Transparent Pricing",
    desc: "Clear and detailed estimates with no hidden fees."
  },
  {
    title: "Quality Parts",
    desc: "Only genuine, high-quality parts used for every service."
  }
];

const WhyChooseUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="why-choose-us-section">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-down">
          <small className="text-uppercase text-warning">Top Reasons</small>
          <h2 className="fw-bold text-white">Why Choose Us</h2>
        </div>

        <div className="row g-4">
          {reasons.map((item, idx) => (
            <div
              className="col-md-6 d-flex"
              key={idx}
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <div className="icon-box d-flex">
                <div className="me-3 fs-1 check-icon">✔️</div>
                <div>
                  <h4 className="text-white">{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
